/*
 * Altisafe Pro — comportements propres aux pages produit « garden edging ».
 *
 * Trois rôles, aucun autre :
 *
 *   1. decorate()  enrichit le sélecteur de variantes NATIF du thème.
 *                  On n'écrit pas un second sélecteur : le panier, le stock et
 *                  le paiement accéléré restent pilotés par variant-picker.js.
 *                  On ne fait qu'injecter, dans chaque <label> existant, la
 *                  ligne de projet, le prix, l'économie réelle et le badge.
 *                  Les données viennent de blocks/altisafe-offer.liquid, qui
 *                  les calcule en Liquid à partir des VRAIS prix Shopify.
 *
 *   2. whens()     n'affiche que le contenu qui correspond à la variante
 *                  choisie (contenu du kit, quantités). Le bon état est déjà
 *                  servi par Liquid : le script ne fait que suivre les
 *                  changements ensuite. Sans JS, la page reste juste.
 *
 *   3. anchors()   les liens « #buy » ramènent à la zone d'achat en douceur,
 *                  et respectent prefers-reduced-motion.
 *
 * PIÈGE IMPORTANT — variant-picker.js recharge la section à chaque changement
 * de variante puis fait « this.innerHTML = ... ». Tout ce qu'on injecte dans
 * les labels est donc effacé à ce moment-là. Un MutationObserver sur l'élément
 * <variant-picker> permet de repeindre juste après ; le drapeau data-as-painted
 * évite la boucle infinie (nos propres écritures re-déclenchent l'observateur).
 */
(function () {
  'use strict';

  var reduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------------
     Utilitaires
     ------------------------------------------------------------------ */

  function parseJSON(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  /* Valeurs d'option actuellement cochées, dans l'ordre des options. */
  function selectedValues(root) {
    var out = [];
    root.querySelectorAll('.variant-picker__option').forEach(function (opt) {
      var checked = opt.querySelector('input[type="radio"]:checked');
      if (checked) {
        out.push(checked.value);
        return;
      }
      var select = opt.querySelector('select');
      if (select) out.push(select.value);
    });
    return out;
  }

  /* ------------------------------------------------------------------
     1. Enrichissement du sélecteur natif
     ------------------------------------------------------------------ */

  function decorate(picker, data) {
    if (!data || !data.values) return;

    picker.querySelectorAll('.variant-picker__option-value').forEach(function (cell) {
      var input = cell.querySelector('input[type="radio"]');
      var label = cell.querySelector('label');
      if (!input || !label) return;

      var entry = data.values[input.value];
      if (!entry) return;

      /* Déjà repeint pour cette valeur : ne rien refaire. */
      if (label.getAttribute('data-as-painted') === input.value) return;

      var badge = '';
      if (entry.badge) {
        badge =
          '<span class="as-opt__badge">' + escapeHTML(entry.badge) + '</span>';
      }

      var desc = '';
      if (entry.desc) {
        desc = '<span class="as-opt__desc">' + escapeHTML(entry.desc) + '</span>';
      }

      /* Économie réelle, en pourcentage, calculée en Liquid depuis les prix
         Shopify. Vide sur l'option de référence et sur toute option qui n'est
         pas réellement plus avantageuse. */
      var save = '';
      if (entry.save) {
        save = '<span class="as-opt__save">' + escapeHTML(entry.save) + '</span>';
      }

      var price = '';
      if (entry.price) {
        price = '<span class="as-opt__price">' + escapeHTML(entry.price) + '</span>';
      }

      label.innerHTML =
        badge +
        '<span class="as-opt__main">' +
        '<span class="as-opt__name">' +
        escapeHTML(entry.name || input.value) +
        '</span>' +
        desc +
        '</span>' +
        '<span class="as-opt__side">' +
        price +
        save +
        '</span>';

      label.setAttribute('data-as-painted', input.value);
      cell.classList.add('as-opt-cell');
      if (entry.badge) cell.classList.add('as-opt-cell--flag');
    });

    picker.classList.add('as-picker-rich');
  }

  function escapeHTML(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ------------------------------------------------------------------
     2. Contenu conditionné à la variante
     ------------------------------------------------------------------

     Convention : un élément portant data-as-when="<valeur d'option>" n'est
     visible que si cette valeur est sélectionnée. Un élément sans cet attribut
     est toujours visible. C'est ainsi que « What's included » annonce le bon
     nombre de piquets sans jamais promettre le contenu d'une autre variante.

     Le bon état est DÉJÀ servi par Liquid : ce script ne fait que suivre les
     changements. Sans JavaScript, la page reste exacte.
     ------------------------------------------------------------------ */

  function whens(values) {
    if (!values.length) return;

    document.querySelectorAll('[data-as-when]').forEach(function (el) {
      var on = values.indexOf(el.getAttribute('data-as-when')) !== -1;
      el.hidden = !on;
    });
  }

  /* Cartes « quelle quantité » : la carte de la variante affichée est
     seulement mieux tenue (bordure verte). On déplace ce marquage, on ne
     masque rien — la comparaison entre tailles doit rester visible. */
  function highlight(values) {
    if (!values.length) return;

    var cards = document.querySelectorAll('[data-as-cov-value]');
    if (!cards.length) return;

    var found = false;
    cards.forEach(function (card) {
      if (values.indexOf(card.getAttribute('data-as-cov-value')) !== -1) found = true;
    });
    /* Aucune correspondance : on laisse le marquage servi par Liquid. */
    if (!found) return;

    cards.forEach(function (card) {
      var on = values.indexOf(card.getAttribute('data-as-cov-value')) !== -1;
      card.classList.toggle('as-pdp-cov__card--on', on);
    });
  }

  /* ------------------------------------------------------------------
     3. Ancres douces
     ------------------------------------------------------------------ */

  function anchors(root) {
    root.querySelectorAll('a[href^="#"]').forEach(function (link) {
      var id = link.getAttribute('href').slice(1);
      if (!id) return;

      link.addEventListener('click', function (event) {
        var target = document.getElementById(id);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({
          behavior: reduced ? 'auto' : 'smooth',
          block: 'start',
        });
        /* Le focus suit le défilement : sans cela, la tabulation repartirait
           du haut de la page pour un lecteur au clavier. */
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      });
    });
  }

  /* ------------------------------------------------------------------
     Amorçage
     ------------------------------------------------------------------ */

  function boot() {
    var dataEl = document.querySelector('[data-as-offer-data]');
    var data = parseJSON(dataEl);
    var picker = document.querySelector(
      '.shopify-section-product-section variant-picker'
    );

    if (picker) {
      var repaint = function () {
        decorate(picker, data);
        var values = selectedValues(picker);
        whens(values);
        highlight(values);
      };

      repaint();

      /* variant-picker.js remplace tout son innerHTML après chaque fetch :
         on repeint dès que le DOM se stabilise.

         PIÈGE — ne PAS utiliser requestAnimationFrame ici. Un onglet en
         arrière-plan ne peint pas : rAF n'y est jamais appelé, et la page
         resterait figée sur l'ancienne variante jusqu'au retour au premier
         plan. setTimeout, lui, s'exécute dans tous les cas. Le délai 0 suffit :
         il ne s'agit que de laisser le navigateur finir de poser le DOM. */
      var pending = 0;
      var schedule = function () {
        window.clearTimeout(pending);
        pending = window.setTimeout(repaint, 0);
      };

      var observer = new MutationObserver(schedule);
      observer.observe(picker, { childList: true, subtree: true });

      /* Le changement de radio est immédiat ; le fetch, lui, arrive après.
         Écouter les deux évite un panneau en retard d'un clic. */
      picker.addEventListener('change', schedule);
    }

    anchors(document.querySelector('main') || document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
